export default __webpack_public_path__ + "static/media/ipad-banner-1.34b2322a.png";